import * as React from "react";
import { Box, Layer, LayerPositionType } from "grommet";
import ScrollContainer from "./ScrollContainer";

const StyledModal = ({ isOpen, setIsOpen, position, children }: { isOpen: boolean; setIsOpen?: Function; position?: LayerPositionType; children: any }) => {
    if (isOpen)
        return (
            <Layer full="vertical" position={position || "right"} responsive={true} onEsc={() => setIsOpen && setIsOpen(false)} onClickOutside={() => setIsOpen && setIsOpen(false)}>
                <ScrollContainer direction={"-y"}>
                    <Box pad="medium">{children}</Box>
                </ScrollContainer>
            </Layer>
        );

    return <></>;
};

export default StyledModal;
